export default "__VITE_ASSET__CdXWIiAi__"